import React, { PropTypes } from 'react';

const PageLoader = ({ title }) => (
  <div className="ui active page dimmer">
    <div className="content">
      <div className="ui large text loader">{title}</div>
    </div>
  </div>
);

PageLoader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageLoader;



// WEBPACK FOOTER //
// ./src/modules/common/components/PageLoader.js